import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function QuickApplyLayout() {
  return (
    <>
      <Helmet>
        <title>Quick Apply</title>
        <link rel="preload" as="font" type="font/otf" href="/Assets/Fonts/GothamRounded-Light.otf" crossorigin="anonymous" />
        <link rel="preload" as="font" type="font/otf" href="/Assets/Fonts/GothamRounded-LightItalic.otf" crossorigin="anonymous" />
        <link rel="preload" as="font" type="font/otf" href="/Assets/Fonts/GothamRounded-Book.otf" crossorigin="anonymous" />
        <link rel="preload" as="font" type="font/otf" href="/Assets/Fonts/GothamRounded-Medium.otf" crossorigin="anonymous" />
        <link rel="preload" as="font" type="font/ttf" href="/Assets/Fonts/GothamRoundedBold_21016.ttf" crossorigin="anonymous" />
      </Helmet>
      <div>
        <main>
          <Outlet />
        </main>
      </div>
    </>
  );
}

export default QuickApplyLayout;
